import { render, staticRenderFns } from "./missionary.vue?vue&type=template&id=b12f156e&scoped=true&"
import script from "./missionary.vue?vue&type=script&lang=js&"
export * from "./missionary.vue?vue&type=script&lang=js&"
import style0 from "./missionary.vue?vue&type=style&index=0&id=b12f156e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b12f156e",
  null
  
)

export default component.exports